<script>
/*global gtag */

import { checkConsentMixin } from './check-consent-mixin'

export default {
  mixins: [checkConsentMixin],

  props: {
    orgParams: {
      type: Object,
      required: false,
      default: null
    }
  },

  methods: {
    trackPage() {
      gtag('js', new Date())

      if (this.orgParams) {
        gtag('config', this.orgParams.gaId, this.orgParams.options)
      }
    }
  }
}
</script>
